import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const checkCustomerSubscription = unaryRpc({
  name: "checkCustomerSubscription",
  input: z.object({
    customerEmail: z.string().email(),
    variantIds: z.array(z.string()).optional(), // Shopify variant IDs to check for specific product subscription
  }),
  output: z.object({
    customerExists: z.boolean(), // Whether customer exists in Recharge
    isSubscribedToProduct: z.boolean(), // Whether subscribed to the specific product/variant
    hasActiveSubscriptions: z.boolean(), // Whether has any active subscriptions
    subscriptionCount: z.number().optional(),
  }),
});
